import * as S from "./MainTemplate.style";
import { Header } from "@/components/organisms/Header";
import { useNavigate } from "react-router";
import { NavigationBar } from "@/components/organisms/NavigationBar";
import { useRecoilValue } from "recoil";
import {
  studentUserState,
  guardianUserState,
  loginTypeState,
} from "@/common/states/user";
import { useQuery } from "@tanstack/react-query";
import { request } from "@/common/api";
import { GET_COUNT_ALARM } from "@/common/querykeys";
import { useState, useEffect, useMemo } from "react";

interface MainTemplateProps {
  nav: boolean;
  subPage: boolean;
  menuBtn: boolean;
  calenderBtn?: boolean;
  children?: React.ReactElement;
  pageTitle?: string;
  buttonLeft?: React.ReactElement;
  buttonBack?: React.ReactElement;
  buttonRight?: React.ReactElement;
  buttonBottom?: React.ReactElement;
  onCalendarClick?: () => void;
}

export const MainTemplate = ({
  nav,
  subPage,
  menuBtn,
  children,
  pageTitle,
  buttonLeft,
  buttonBack,
  buttonRight,
  calenderBtn,
  buttonBottom,
  onCalendarClick,
}: MainTemplateProps) => {
  const navigate = useNavigate();
  const student = useRecoilValue(studentUserState);
  const loginType = useRecoilValue(loginTypeState);
  const guardian = useRecoilValue(guardianUserState);

  // 헤더 햄버거 메뉴버튼 알림 유무 표시
  const [isAlarm, setIsAlarm] = useState(false);

  function handleMenuOpen() {
    navigate("/setting");
  }

  // 학생 || 보호자의 아이디 조회
  const studentId = useMemo(() => {
    return loginType === "student" ? student?.id : guardian?.id;
  }, [student, guardian, loginType]);

  /**
   * 기존의 알림 카운트 조회 api 재사용
   * 헤더의 햄버거 메뉴버튼에 알림 유무 표시 위해  countUnRead | countUnReadNotice
   */
  const { data: alarmData } = useQuery({
    queryKey: [GET_COUNT_ALARM, "Header"],
    queryFn: async () => {
      const result = await request<any>({
        method: "GET",
        url: `/push-alarm/count-alarm/${studentId}`,
      });

      return result; // 항상 result 값을 반환
    },
  });

  // 알림 데이터가 변경될 때마다 알림 상태 업데이트
  useEffect(() => {
    if (alarmData) {
      /**
       * 이벤트 및 공지(countUnReadNotice) 와 알림관리(countUnRead) 카운트가 0이면 false 설정
       * 하나라도 알림 카운트가 0이 아니면 true 설정
       */
      if (
        alarmData?.countUnRead === "0" &&
        alarmData?.countUnReadNotice === "0"
      ) {
        setIsAlarm(false);
      } else {
        setIsAlarm(true);
      }
    }
  }, [alarmData]);

  return (
    <>
      <S.MainTemplate $subPage={subPage} $nav={nav}>
        <>
          <Header
            headerTitle={pageTitle}
            buttonLeft={buttonLeft}
            buttonRight={buttonRight}
            buttonMenu={menuBtn}
            calenderBtn={calenderBtn}
            handleMenuOpen={handleMenuOpen}
            isAlarm={isAlarm}
            onCalendarClick={onCalendarClick}
          />
          <S.MainContentBox $button={buttonBottom ? true : false}>
            {children}
            {buttonBottom && (
              <S.MainButtonBox $backButton={buttonBack ? true : false}>
                {buttonBack && buttonBack}
                {buttonBottom}
              </S.MainButtonBox>
            )}
          </S.MainContentBox>
          {nav && <NavigationBar />}
        </>
      </S.MainTemplate>
    </>
  );
};
